import API from '@/API'

const login = async ({
    commit
}, login_data) => {
    try {
        const {
            data
        } = await API.post('user/login', {
            phone: login_data.phone,
            password: login_data.password
        })
        if (data.error != 0) {
            throw new Error(data)
        } else {
            commit('LogIn')
            localStorage.token = data.token
            return data
        }
    } catch (data) {
        return data
    }
}

const logout = async ({
    commit
}) => {
    commit('LogOut')
    localStorage.token = ""
}

const getHomeData = async ({
    commit
}) => {
    try {
        const {
            data
        } = await API.get('home')

        if (data.error != 0) {
            throw new Error(data)
        } else {
            return data
        }

    } catch (error) {
        return error
    }
}

const getProducts = async ({
    commit
}, product) => {
    const {offset , limit , selectedFamilyId} = product
    try {
        const {
            data
        } = await API.get(`product?offset=${offset}&limit=${limit}&family=${selectedFamilyId}`)

        if (data.error != 0) {
            throw new Error(data)
        } else {
            return data
        }

    } catch (error) {
        return error
    }
}

const searchProduct = async ({
    commit
}, input) => {
    try {
        const {
            data
        } = await API.get(`product/search?p=${input}`)

        if (data.error != 0) {
            throw new Error(data)
        } else {
            return data
        }

    } catch (error) {
        return error
    }
}

const getAllProductFamily = async ({
    commit
}) => {
    try {
        const {
            data
        } = await API.get('family')

        if (data.error != 0) {
            throw new Error(data)
        } else {
            return data
        }

    } catch (error) {
        return error
    }
}

const addProduct = async ({
    commit
}, product_data) => {
    try {
        let formData = new FormData()
        const {
            product_image,
            product_name,
            product_family,
            rack,
            retail_price_gamma,
            wholesale_price,
            retail_price_alpha,
            retail_price_beta
        } = product_data

        formData.append('product_image', product_image)
        formData.append('product_name', product_name)
        formData.append('product_family', product_family)
        formData.append('rack', rack)
        formData.append('retail_price_gamma', retail_price_gamma)
        formData.append('wholesale_price', wholesale_price)
        formData.append('retail_price_alpha', retail_price_alpha)
        formData.append('retail_price_beta', retail_price_beta)

        const {
            data
        } = await API.post('product', formData)

        if (data.error != 0) {
            throw new Error(data.error)
        } else {
            return data
        }

    } catch (error) {
        return error
    }


}

const updateProduct = async ({
    commit
}, product_data) => {
    try {
        let formData = new FormData()
        const {
            product_id,
            product_image,
            product_name,
            product_family,
            rack,
            retail_price_gamma,
            wholesale_price,
            retail_price_alpha,
            retail_price_beta
        } = product_data
        formData.append('product_id', product_id)
        formData.append('product_image', product_image)
        formData.append('product_name', product_name)
        formData.append('product_family', product_family)
        formData.append('rack', rack)
        formData.append('retail_price_gamma', retail_price_gamma)
        formData.append('wholesale_price', wholesale_price)
        formData.append('retail_price_alpha', retail_price_alpha)
        formData.append('retail_price_beta', retail_price_beta)

        const {
            data
        } = await API.put('product', formData)

        if (data.error != 0) {
            throw new Error(data.error)
        } else {
            return data
        }

    } catch (error) {
        return error
    }


}

const getFamily = async ({
    commit
}, offset = 0, limit = 10) => {
    try {
        const {
            data
        } = await API.get('family')

        if (data.error != 0) {
            throw new Error(data)
        } else {
            return data
        }

    } catch (error) {
        return error
    }
}

const addFamily = async ({
    commit
}, family_name) => {
    try {
        const {
            data
        } = await API.post('family',
            family_name
        )

        if (data.error != 0) {
            throw new Error(data.error)
        } else {
            return data
        }

    } catch (error) {
        return error
    }


}
const updateFamily = async ({
    commit
}, family_data) => {
    try {
        const {
            data
        } = await API.put('family',
            family_data
        )

        if (data.error != 0) {
            throw new Error(data.error)
        } else {
            return data
        }

    } catch (error) {
        return error
    }


}

const deleteProduct = async ({
    commit
}, product_data) => {
    try {
        const {
            product_id
        } = product_data

        const {
            data
        } = await API.delete(`product/${product_id}`)

        if (data.error != 0) {
            throw new Error(data.error)
        } else {
            return data
        }

    } catch (error) {
        return error
    }
}

const deleteFamily = async ({
    commit
}, family_data) => {
    try {
        const {
            family_id
        } = family_data

        const {
            data
        } = await API.delete(`family/${family_id}`)

        if (data.error != 0) {
            throw new Error(data.error)
        } else {
            return data
        }

    } catch (error) {
        return error
    }
}

const searchFamily = async ({
    commit
}, input) => {
    try {
        const {
            data
        } = await API.get(`family/search?f=${input}`)

        if (data.error != 0) {
            throw new Error(data)
        } else {
            return data
        }

    } catch (error) {
        return error
    }
}

const getInvoiceNo = async ({
    commit
}) => {
    try {
        fetch('https://jsonstorage.net/api/items/a750f7df-b783-4146-8a78-0df553ce4cca')
            .then(
                response => response.json()

            ).then((data) => {
                console.log(data)
                const {
                    invoice: invoiceNo
                } = data
                commit('setInvoiceNo', invoiceNo)
            })
            .catch((error) => {
                throw new Error(error)
            })

    } catch (error) {
        return error
    }
}

const updateInvoiceNo = async ({
    commit,state
}) => {
    try {
        let invoice_number  = state.invoiceNo
            const data = {
                invoice:++invoice_number
            }
    
            fetch('https://jsonstorage.net/api/items/a750f7df-b783-4146-8a78-0df553ce4cca', {
                    method: 'PUT',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify(data),
                })
                .then(response => response.json())
                .then(data => {
                    console.log('Success:', data)
                })
                .catch((error) => {
                    console.error('Error:', error)
                });
            
        

    } catch (error) {
        return error
    }
}

const getWholeFamily = async ({
    commit
}) => {
    try {
        const {
            data
        } = await API.get('family/whole-family')

        if (data.error != 0) {
            throw new Error(data)
        } else {
            return data
        }

    } catch (error) {
        return error
    }
} 

const getProductsFilterByFamily = async ({
    commit
}, familyData) => {
    try {
        const {
            familyId
        } = familyData

        const {
            data
        } = await API.get(`product?offset=0&limit=10&family=${familyId}`)

        if (data.error != 0) {
            throw new Error(data)
        } else {
            return data
        }

    } catch (error) {
        return error
    }
}
export {
    login,
    getHomeData,
    getProducts,
    searchProduct,
    getAllProductFamily,
    addProduct,
    updateProduct,
    getFamily,
    addFamily,
    updateFamily,
    deleteProduct,
    deleteFamily,
    searchFamily,
    logout,
    getInvoiceNo,
    updateInvoiceNo,
    getWholeFamily,
    getProductsFilterByFamily
}